/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const productDetailsNameSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-lg)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: '800',
	opacity: 1,
	textTransform: 'uppercase',
};

export const familyDetailsSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#505050',
	fontWeight: 'normal',
	opacity: 1,
	marginBottom: '3px',
};
